import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AdditionalCost, AdditionalCostsSaveOffer } from 'src/app/shared/models/AdditionalCost';
import { EventsService } from '../events.service';
import { forkJoin } from 'rxjs';
import { Event } from 'src/app/shared/models/Event';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-request-event-additional-cost',
    templateUrl: './request-event-additional-cost.component.html',
    styleUrls: ['./request-event-additional-cost.component.scss'],
    standalone: false
})
export class RequestEventAdditionalCostComponent implements OnInit {

  @Input()
  event: Event;

  // tslint:disable-next-line:no-output-on-prefix
  @Output()
  onEventUpdate: EventEmitter<Event> = new EventEmitter<Event>();

  public additionalCostsCustomArray: {
    id: number, name: string, cost: number, typeShow: string, typeField: string, title: string,
    text: string, priceLabel: string, originalValue: number, value: number, endRow: boolean, quantity: number, offset: number, requestedAt: string
  } [] = [];

  public additionalCostsArray: AdditionalCost[] = [];
  public additionalCostsAssignedArray: any[] = [];

  constructor(private _eventsService: EventsService, private _toastr: ToastrService) { }

  ngOnInit() {
    const eventId = this.event.id;
    forkJoin([
      this._eventsService.getAdditionalCosts(),
      this._eventsService.getAdditionalCostsAssigned(eventId.toString())
    ]).subscribe(result => {
      this.additionalCostsArray = [...result[0]];
      this.additionalCostsAssignedArray = [...result[1]];
      this._updateAdditionalCostObject();
    });
  }

  private _updateAdditionalCostObject () {

    this.additionalCostsArray.forEach(rec => {
      const obj: {
        id: number, name: string, cost: number, typeShow: string, typeField: string, title: string,  text: string,
        priceLabel: string, originalValue: number, value: number, endRow: boolean, quantity: number, offset: number, requestedAt: string
      } = {
        id: 0, name: '', cost: 0, typeShow: '', typeField: '', title: '', text: '',
        priceLabel: '', originalValue: 0, value: 0, endRow: false, quantity: 0, offset: 1, requestedAt: ''
      };
      const arrayFilter = this.additionalCostsAssignedArray.filter(item => item.id === rec.id);
      let quantity = 0;
      let value = 0;
      let requestedAt = '';
      if (arrayFilter.length === 1) {
        quantity =  arrayFilter[0].quantity;
        value =  arrayFilter[0].quantity;
        requestedAt = arrayFilter[0].requestedAt;
      }
      obj.requestedAt = requestedAt;
      obj.id = rec.id;
      obj.name = rec.name;
      obj.cost = rec.cost;
      obj.title = rec.name;
      if (rec.id === 12) {
        obj.offset = 10;
      }
      switch (rec.type) {
        case 1:
          obj.typeShow = 'showPerc';
          break;
        case 2:
          obj.typeShow = 'showValue';
          break;
        case 3:
          obj.typeShow = 'showLabel';
          break;
      }
      switch (rec.name) {
        case 'beltBag':
        case 'wallet':
        case 'cashDrawer':
        case 'sticker':
        case 'vivaWallet':
        case 'sumUp':
        case 'worldLine':
          obj.typeField = 'groupNumber';
          obj.quantity = 0;
          obj.value = quantity;
          break;
        case 'badWeather':
        case 'pickupInstalled':
        case 'uploadingCheckingPricelist':
        case 'training':
        case 'stockManagement':
        case 'simCard':
        case 'tapToPayHelp':
          obj.typeField = 'radio';
          obj.quantity = quantity;
          obj.value = quantity;
          break;
        case 'cancellation':
          obj.typeField = 'simpleText';
          break;
      }
      obj.endRow = (rec.name === 'training');
      obj.originalValue = value;
      if (rec.name !== 'cancellation') {
        this.additionalCostsCustomArray.push(obj);
      }
    });

  }

  public onAdditionalCostNumberInputChange(name) {
    const additionalCostObject = this.additionalCostsCustomArray.filter(item => item.name === name)[0];
    additionalCostObject.value = additionalCostObject.originalValue + additionalCostObject.quantity;
  }

  public saveData() {
    this.event.eventAdditionalCosts = [];
    this.event.additionalCosts = [];
    this.additionalCostsCustomArray.forEach(element => {
        const additionalCost: AdditionalCost = {
          id: element.id,
          name: element.name,
          cost: element.cost,
          type: element.name == 'badWeather' ? 1 : 2,
          quantityRequested: element.typeField === 'radio' ? element.originalValue !== element.quantity ? element.quantity : undefined : element.quantity,
          quantity: element.value,
          requestedAt: element.requestedAt !== '' ? element.requestedAt : null,
        }
        const additionalCostSaveOffer: AdditionalCostsSaveOffer = {
          id: element.id,
          quantity: element.value,
        }
        this.event.eventAdditionalCosts.push(additionalCost)
        this.event.additionalCosts.push(additionalCostSaveOffer);
    });
    if (this.event.eventAdditionalCosts.filter(c => c.id === 9)[0]?.quantity > 0) {
      this.event.hasVivaWallet = true;
    } else {
      this.event.hasVivaWallet = false;
    }
    if (this.event.eventAdditionalCosts.filter(c => c.id === 10)[0]?.quantity > 0) {
      this.event.hasSumUp = true;
    } else {
      this.event.hasSumUp = false;
    }
    if (this.event.eventAdditionalCosts.filter(c => c.id === 13)[0]?.quantity > 0) {
      this.event.hasWorldLine = true;
    } else {
      this.event.hasWorldLine = false;
    }
    this._eventsService.updateEvent(this.event, true).subscribe(result => {
      this._toastr.success('Additional costs added successfully');
      this.onEventUpdate.emit(this.event);
        window.location.reload();
    });
  }


}
